import { useState } from "react";
import { Facebook, Link2, MessageCircle, Check } from "lucide-react";

export function ProductShareLinks({ productName, productUrl }: { productName: string; productUrl: string }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(productUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const iconClass =
    "h-9 w-9 rounded-full flex items-center justify-center border border-border text-ink-muted hover:text-ink hover:border-ink-muted transition-colors duration-200";

  return (
    <div className="flex items-center gap-2">
      <a
        href={`https://wa.me/?text=${encodeURIComponent(`${productName} — ${productUrl}`)}`}
        target="_blank"
        rel="noreferrer"
        aria-label="Share on WhatsApp"
        className={iconClass}
      >
        <MessageCircle size={16} />
      </a>
      <a
        href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(productUrl)}`}
        target="_blank"
        rel="noreferrer"
        aria-label="Share on Facebook"
        className={iconClass}
      >
        <Facebook size={16} />
      </a>
      <button type="button" onClick={handleCopy} aria-label="Copy product link" className={iconClass}>
        {copied ? <Check size={16} className="text-emerald-500" /> : <Link2 size={16} />}
      </button>
    </div>
  );
}
